/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable max-len */

/* eslint-disable quote-props */
export const CARD_LIST_PER_PAGE = 5;

export const CATEGORY_NAME_UNCATEGORIZED = "区分なし";

export const TRAINING_TYPE_CAREER = 0;
export const TRAINING_TYPE_QUALIFICATION = 10;
export const TRAINING_TYPE_CURRICULUM = 90;
export const TrainingTypes: { [key: number]: string } = {};
TrainingTypes[TRAINING_TYPE_CAREER] = "講座"; // XXX SOMPOでは「研修」=「講座」
TrainingTypes[TRAINING_TYPE_QUALIFICATION] = "スキル";
TrainingTypes[TRAINING_TYPE_CURRICULUM] = "カリキュラム";
export type TrainingType = keyof typeof TrainingTypes;

export const CareerTypes = {
    ELEARNING: "1", // e-ラーニング
    CLASSROOM: "2", // 集合研修
    DLEARNING: "3", // 通信教育
    QUALIFICATION: "10", // スキル≒資格
    CURRICULUM: "90", // カリキュラム
    fromLabel: (label: string) => {
        switch (label) {
            case "eラーニング":
                return CareerTypes.ELEARNING;
            case "集合研修":
                return CareerTypes.CLASSROOM;
            default:
                return "";
        }
    },
};
export const CAREER_TYPE_ELEARNING = CareerTypes.ELEARNING;
export const CAREER_TYPE_CLASSROOM = CareerTypes.CLASSROOM;
export const CAREER_TYPE_DLEARNING = CareerTypes.DLEARNING;
export const CAREER_TYPE_QUALIFICATION = CareerTypes.QUALIFICATION;
export const CAREER_TYPE_CURRICULUM = CareerTypes.CURRICULUM;

// 研修ステータス
export type CareerStatus =
    | "0"
    | "1"
    | "2"
    | "3"
    | "4"
    | "5"
    | "6"
    | "7"
    | "8"
    | "9"
    | "11"
    | "12"
    | "13"
    | "14"
    | "16"
    | "17"
    | "18"
    | "19"
    | "20"
    | "21";
export const CAREER_STATUS_APPLYING_ATTEND = "0";
export const CAREER_STATUS_APPLYING_CANCEL = "1";
export const CAREER_STATUS_BEFORE_PERIOD = "2";
export const CAREER_STATUS_UNLEARNED = "3";
export const CAREER_STATUS_LEARNING = "4";
export const CAREER_STATUS_DOING = "5";
export const CAREER_STATUS_APPLYING_RECORD = "6";
export const CAREER_STATUS_COMPLETED = "7";
export const CAREER_STATUS_NOT_COMPLETED = "8";
export const CAREER_STATUS_INVALID = "9";
export const CAREER_STATUS_NOT_COMPLETED_DISABLED = "11";
export const CAREER_STATUS_NOT_COMPLETED_CANCELED = "12";
export const CAREER_STATUS_NOT_COMPLETED_SUSPENDED = "13";
export const CAREER_STATUS_NOT_LEARNED = "14";
export const CAREER_STATUS_APPLYING_EXECUTE = "16";
export const CAREER_STATUS_CERTIFIED = "17";
export const CAREER_STATUS_NOT_CERTIFIED = "18";
export const CAREER_STATUS_NOT_CERTIFIED_DISABLED = "19";
export const CAREER_STATUS_NOT_CERTIFIED_CANCELED = "20";
export const CAREER_STATUS_NOT_EXECUTED = "21";
export const CareerStatuses = {
    "0": "受講申請中",
    "1": "取消申請中",
    "2": "期間前",
    "3": "未学習",
    "4": "学習中",
    "5": "実施中",
    "6": "実績申請中",
    "7": "修了",
    "8": "未修了",
    "9": "失効",
    "11": "未修了(受講不可)",
    "12": "未修了(キャンセル)",
    "13": "未修了(クラス中止)",
    "14": "未受講",
    "16": "実施申請中",
    "17": "認定",
    "18": "未認定",
    "19": "未認定(実施不可)",
    "20": "未認定(キャンセル)",
    "21": "未実施",
};
export const getCareerStatusLabel = (status: CareerStatus): string => CareerStatuses[status];

// 資格(スキル)ステータス
export type QualificationStatus =
    | "0"
    | "1"
    | "2"
    | "3"
    | "4"
    | "5"
    | "6"
    | "7"
    | "8"
    | "9"
    | "11"
    | "12"
    | "13"
    | "14"
    | "16"
    | "17"
    | "18"
    | "19"
    | "20"
    | "21";
export const QUALIFICATION_STATUS_APPLYING_EXECUTE1 = "0";
export const QUALIFICATION_STATUS_APPLYING_CANCEL = "1";
export const QUALIFICATION_STATUS_BEFORE_PERIOD = "2";
export const QUALIFICATION_STATUS_UNLEARNED = "3";
export const QUALIFICATION_STATUS_LEARNING = "4";
export const QUALIFICATION_STATUS_DOING = "5";
export const QUALIFICATION_STATUS_APPLYING_RECORD = "6";
export const QUALIFICATION_STATUS_COMPLETED = "7";
export const QUALIFICATION_STATUS_NOT_COMPLETED = "8";
export const QUALIFICATION_STATUS_INVALID = "9";
export const QUALIFICATION_STATUS_NOT_COMPLETED_DISABLED = "11";
export const QUALIFICATION_STATUS_NOT_COMPLETED_CANCELED = "12";
export const QUALIFICATION_STATUS_NOT_COMPLETED_SUSPENDED = "13";
export const QUALIFICATION_STATUS_NOT_LEARNED = "14";
export const QUALIFICATION_STATUS_APPLYING_EXECUTE2 = "16";
export const QUALIFICATION_STATUS_CERTIFIED = "17";
export const QUALIFICATION_STATUS_NOT_CERTIFIED = "18";
export const QUALIFICATION_STATUS_NOT_CERTIFIED_DISABLED = "19";
export const QUALIFICATION_STATUS_NOT_CERTIFIED_CANCELED = "20";
export const QUALIFICATION_STATUS_NOT_EXECUTED = "21";
export const QualificationStatuses = {
    "0": "実施申請中",
    "1": "取消申請中",
    "2": "期間前",
    "3": "未学習",
    "4": "学習中",
    "5": "実施中",
    "6": "実績申請中",
    "7": "認定",
    "8": "未認定",
    "9": "失効",
    "11": "未認定(実施不可)",
    "12": "未認定(キャンセル)",
    "13": "未認定(クラス中止)",
    "14": "未実施",
    "16": "実施申請中",
    "17": "認定",
    "18": "未認定",
    "19": "未認定(実施不可)",
    "20": "未認定(キャンセル)",
    "21": "未実施",
};
export const getQualificationStatusLabel = (status: QualificationStatus): string => QualificationStatuses[status];

// カリキュラムステータス
export type CurriculumStatus = "1" | "2" | "3" | "4" | "5" | "6";
export const CURRICULUM_STATUS_APPLYING_ATTEND = "1";
export const CURRICULUM_STATUS_DOING = "2";
export const CURRICULUM_STATUS_CANCEL_LEARN = "3";
export const CURRICULUM_STATUS_COMPLETED = "4";
export const CURRICULUM_STATUS_INVALID = "5";
export const CURRICULUM_STATUS_NOT_LEARNED = "6";
export const CurriculumStatuses = {
    "1": "受講申請中",
    "2": "実施中",
    "3": "受講取消",
    "4": "修了",
    "5": "失効",
    "6": "未受講",
};
export const getCurriculumStatusLabel = (status: CurriculumStatus): string => CurriculumStatuses[status];

// スキルマップ-達成状況
export type SkillMapStatus = "0" | "1" | "2";
export const SkillMapStatuses = {
    "0": "未着手",
    "1": "実施中",
    "2": "達成",
};
export const getSkillMapStatusLabel = (status: SkillMapStatus): string => SkillMapStatuses[status] || SkillMapStatuses["0"];

// スキルマップ-優先設定
export type SkillMapPriority = "0" | "1";
export const SKILL_MAP_PRIORITY_NORMAL = "0";
export const SKILL_MAP_PRIORITY_PRIORITIZE = "1";
export const SkillMapPriorities = {
    "0": "",
    "1": "○",
};
export const getSkillMapPriorityLabel = (priority: SkillMapPriority): string => SkillMapPriorities[priority];

export const CLASSIFICATION_NEW = "新着";
export const CLASSIFICATION_REQUIRED = "必須";

// スキルマップ：達成状況
export const SkillMapCellStatus = {
    // 未着手
    NOT_STARTED: "0",

    // 実施中
    CARRIED_OUT: "1",

    // 達成
    ACHIEVED: "9",
};

// スキルマップ：目標種別
export const TargetType = {
    // 未設定
    UNSET: "-1",

    // 短期目標
    SHORT_TERM: "0",

    // 長期目標
    LONG_TERM: "1",
};

// スキルマップ：ステータス
export const TargetStatus = {
    // 未設定
    UNSET: 0,

    // 設定済
    SET: 1,
};

// 講座ラジオボタン：ステータス種別
export const CareerStatusType = {
    // すべて
    ALL: "0",

    // 申請中
    APPLYING: "1",

    // 受講中
    DOING: "2",
};

// 受講ボタンの表示ステータス：/[onGoing|result]/eLGridList[].jukou
export const AttendButtonStatus = {
    // 表示: 1
    VISIBLE: "1",

    // 非表示: 1
    HIDDEN: "0",
};

export const AccessLevel = {
    // 一般ユーザ
    NORMAL: "0",

    // 講師
    INSTRUCTOR: "1",

    // 主催者
    ORGANIZER: "2",

    // 進捗管理者
    PROGRESS_MANAGER: "3",

    // 法人管理者
    COMPANY_MANAGER: "4",

    // スーパーユーザ
    SUPER_USER: "5",
};

// 講座 区分が必須
export const ITEM_ID_DIVISION = "PC10";
export const CLASS_REQUIRED_EL = "CLASS_REQUIRED_EL";
export const CLASS_REQUIRED_GT = "CLASS_REQUIRED_GT";
export const CLASS_REQUIRED_CU = "CLASS_REQUIRED_CU";
export const COMPULSORY_ID_REQUIRED = "必須";

// メッセージ一覧：操作タイプ(取得)
export const MESSAGE_KIND_GET = "0";

// LM標準起動でwindow.openする際にtargetに指定するコンテキスト
export const PORTAL_LM_WINDOW = "PORTAL_LM_WINDOW";

export const APPROVER_SELECTION_REQUIRED = 1;
export const APPROVER_SELECTION_UNNECESSARY = 0;

// 講座・カリキュラム詳細画面のモバイル版で使用するフッターのボタンの高さ
export const HEIGHT_MOBILE_FOOTER = "70px";
